// PRODUCTION PAYPAL ID
export const CLIENT_ID = 'ATtKa6fhG4arcq6jFTS2VxnJ0ffKikB4uXNnT5dPN-H8eCJa2HDBvUzHWgqXVB8G7ZxksRrOJ3SJAY9B';

// DEV PAYPAL ID
// export const CLIENT_ID = 'AWoPEfHhq0NjRJLEgArrWYE_PidVs0tDH36m6ND8IjP-6hC5SeLVqAQY0C-JpuNqrS55xEu_x8Q-hdCC';